<div class="panel__content no-padding fleet-overview-table">
    <div *ngIf="equipmentDataLoading || _loading != 0" [class.loading-initial]="equipmentDataLoading" [class.loading-next-page]="_loading != 0">
      <mat-spinner></mat-spinner>
    </div>
    <mat-table *ngIf="!equipmentDataLoading && _loading == 0" class="table-material table-material--striped table-material--hover table-material--full-width" #table [dataSource]="dataSource" matSort (matSortChange)="sortChanged($event)" [@fadeInOut]  [matSortActive]="_currentSort.active" matSortDisableClear [matSortDirection]="_currentSort.direction">
        <ng-container matColumnDef="modelImage">
            <mat-header-cell class="eval-header" *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let row" class="mat-cell table__eval-cell"><img class="model-image" src="/Api/Application/getModelThumbnail/?modelId={{row.modelId}}" /></mat-cell>
        </ng-container>
        <ng-container matColumnDef="EvalL">
            <mat-header-cell class="eval-header" mat-sort-header *matHeaderCellDef>{{ Translate('Eval (L)')}}  </mat-header-cell>
            <mat-cell *matCellDef="let row" class="mat-cell table__eval-cell"><div [class]="'Eval-'+row.EvalL">{{row.EvalL}}</div></mat-cell>
        </ng-container>
        <ng-container matColumnDef="EvalR">
            <mat-header-cell class="eval-header" mat-sort-header *matHeaderCellDef>{{ Translate('Eval (R)')}}  </mat-header-cell>
            <mat-cell *matCellDef="let row" class="mat-cell table__eval-cell"><div [class]="'Eval-'+row.EvalR">{{row.EvalR}}</div></mat-cell>
        </ng-container>
        <ng-container matColumnDef="customer">
            <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Customer')}}  </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.customerName}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="serial">
            <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Serial No.')}}  </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.serial}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="unit">
            <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Unit No.')}}  </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.unit}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="make">
            <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Make')}}  </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.make}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="model">
            <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Model')}}  </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.model}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="family">
            <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Family')}}  </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.family}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="smu">
            <mat-header-cell  mat-sort-header *matHeaderCellDef>{{ Translate('SMU/Hourmeter')}}  </mat-header-cell>
            <mat-cell *matCellDef="let row" class="text-center"> {{row.smu}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="ltd">
            <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('LTD')}}  </mat-header-cell>
            <mat-cell *matCellDef="let row" class="text-center"> {{row.ltd}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="lastInspectionDate">
            <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Last Inspection Date')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="text-center"> <span>{{(row.lastInspectionDateAsDate | date : 'dd/MMM/yyyy')}}</span></mat-cell>
        </ng-container>
        <ng-container matColumnDef="nextInspection">
            <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Next Inspection Date SMU/Hourmeter')}}</mat-header-cell>
            <mat-cell  class="text-center" *matCellDef="let row">
            <span *ngIf="row.NextInspectionDate == '1900-01-01T00:00:00'">-</span>
            <span *ngIf="row.NextInspectionDate != '1900-01-01T00:00:00'" class="component-span top {{getNextInspectionCSSClass(row.NextInspectionDate)}}">{{(row.NextInspectionDate | date : 'dd-MMM-yyyy')}}/{{row.NextInspectionSMU}}</span></mat-cell>
        </ng-container>
      <!--
        <ng-container matColumnDef="openInNewTab">
            <mat-header-cell class="hover-new-tab__header ignore-click" *matHeaderCellDef></mat-header-cell>
            <mat-cell class="hover-new-tab__cell ignore-click overflow-hidden" *matCellDef="let row">
                <div class="expand-on-hover__element">
                    <button mat-icon-button (click)="openEquipmentNewTab($event, row.Id)" class="ignore-click new-tab-button" matTooltip="Open in new tab">
                        <mat-icon aria-label="Open in new tab" class="ignore-click">open_in_new</mat-icon>
                    </button>
                </div>
            </mat-cell>
        </ng-container>-->
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" class="hand-pointer expand-on-hover" (click)="rowClicked($event, row.Id)"></mat-row>
    </mat-table>
    <mat-paginator [hidden]="equipmentDataLoading" #paginator
                   [pageSize]="loadSize"
                   [pageSizeOptions]="[5, 10, 25, 100]"
                   (page)="pageChanged($event)">
    </mat-paginator>
</div>
<div class='over-cover'></div>
